export enum ActionType {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  TEMPLATE = 'TEMPLATE',
  DEACTIVATE = 'DEACTIVATE',
  REACTIVATE = 'REACTIVATE',
  DELETE = 'DELETE',
  ADD_TO_CALENDAR = 'ADD_TO_CALENDAR',
  ADD_TO_CALENDAR_GOOGLE = 'ADD_TO_CALENDAR_GOOGLE',
  ADD_TO_CALENDAR_OUTLOOK = 'ADD_TO_CALENDAR_OUTLOOK',
  MANANGE_OKRS = 'MANANGE_OKRS',
  SHOW_ONE_OFF_MENU = 'SHOW_ONE_OFF_MENU',
  CREATE_ONE_OFF_NOW = 'CREATE_ONE_OFF_NOW',
  CREATE_ONE_OFF_LATER = 'CREATE_ONE_OFF_LATER',
}

export enum MenuItemActionType {
  RESCHEDULE = 'RESCHEDULE',
  ADD_TO_CALENDAR = 'ADD_TO_CALENDAR',
  DELETE = 'DELETE',
  ADD_TO_CALENDAR_GOOGLE = 'ADD_TO_CALENDAR_GOOGLE',
  ADD_TO_CALENDAR_OUTLOOK = 'ADD_TO_CALENDAR_OUTLOOK',
}
